export default {
    props: {
        modelValue: {
            type: Number,
            default: 0
        },
        prefix: {
            type: String,
            default: ""
        },
        suffix: {
            type: String,
            default: ""
        },
        reverse: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        absValue () {
            return Math.abs(this.modelValue);
        },
        iconType (v) {
            if (this.modelValue == 0) {
                v = 'Z';
            } else if (this.modelValue < 0) {
                v = 'N';
            } else if (this.modelValue > 0) {
                v = 'P';
            }
            return v;
        },
        type (v) {
            if (this.modelValue == 0) {
                v = 'Z';
            } else if (this.modelValue < 0) {
                v = this.reverse ? 'P' : 'N';
            } else if (this.modelValue > 0) {
                v = this.reverse ? 'N' : 'P';
            }
            return v;
        }
    }
};
